import React, { useCallback } from 'react';
import { Box, Grid, Text } from '@chakra-ui/react';
import { styles } from './datepicker-component.styles';
import './datepicker-component.scss';
import { Button } from '../button/button';
import { ButtonVariant } from '../../core/enums';
import { BiomeIcon, IconName } from '@codametrix/verdigris';

export type DatePickerHeaderProps = {
  dayPicker?: boolean;
  handleClearDate?: () => void;
  isClearBtnDisabled?: boolean;
  monthDate?: any;
  monthPicker?: boolean;
  onMonthClick?: () => void;
  onMonthPickerYearClick?: () => void;
  onLeftArrowClick?: () => void;
  onRightArrowClick?: () => void;
  onYearClick?: () => void;
  yearPicker?: boolean;
  selectedYear?: string;
  yearRange?: string;
};

const DatePickerHeader: React.FC<DatePickerHeaderProps> = props => {
  const {
    onMonthClick,
    onMonthPickerYearClick,
    onYearClick,
    onRightArrowClick,
    onLeftArrowClick,
    handleClearDate,
    monthDate,
    dayPicker,
    monthPicker,
    yearPicker,
    yearRange,
    selectedYear,
    isClearBtnDisabled
  } = props;

  const classes = styles();

  const getMonthAndYear = useCallback(() => {
    return (
      monthDate
        ?.toLocaleString('en-US', {
          month: 'long',
          year: 'numeric'
        })
        .split(' ') ?? null
    );
  }, [monthDate]);

  const month = getMonthAndYear() && getMonthAndYear()[0];
  const year = getMonthAndYear() && getMonthAndYear()[1];
  return (
    <div className="datepicker-component">
      <Box sx={classes.root}>
        <Grid sx={classes.header}>
          <Box onClick={onLeftArrowClick}>
            <BiomeIcon
              iconName={IconName.Chevron_Left}
              iconClass={`${classes.icon}`}
              iconSize="12"
            />
          </Box>
          <Grid sx={classes.title}>
            {dayPicker && (
              <>
                <Text
                  className="react-datepicker__current-month"
                  style={classes.icon}
                  onClick={onMonthClick}>
                  {month}
                </Text>
                <Text
                  className="react-datepicker__current-month"
                  style={classes.icon}
                  onClick={onYearClick}>
                  {year}
                </Text>
              </>
            )}
            {yearPicker && (
              <Text className="react-datepicker__current-month">
                {yearRange}
              </Text>
            )}
            {monthPicker && (
              <Text
                className="react-datepicker__current-month"
                onClick={onMonthPickerYearClick}
                style={classes.icon}>
                {selectedYear}
              </Text>
            )}
          </Grid>
          <Box onClick={onRightArrowClick}>
            <BiomeIcon
              iconName={IconName.Chevron_Right}
              iconSize="12"
              iconClass={`${classes.icon}`}
            />
          </Box>
        </Grid>
        <div>
          <Button
            label={'Clear'}
            variant={ButtonVariant.LINKS}
            onClick={handleClearDate}
            sx={isClearBtnDisabled ? classes.disabledBtn : classes.clearBtn}
          />
        </div>
      </Box>
    </div>
  );
};

DatePickerHeader.displayName = 'DatePickerHeader';
export { DatePickerHeader };
